import React from 'react';

import { PresetListContainer, PresetItem, PresetLabel, PresetCheck, PresetDefault } from './styles';
import { TimePreset } from './timeframe-picker';

import { Icon } from '@controlrooms/components';
import { TimePresetKeyType } from '@controlrooms/models';

interface PresetListProps {
  presets: TimePreset[];
  selectedPreset?: TimePresetKeyType;
  onPresetSelect: (preset: TimePreset) => void;
}

export const PresetList: React.FC<PresetListProps> = ({
  presets,
  selectedPreset,
  onPresetSelect,
}) => {
  return (
    <PresetListContainer>
      {presets.map((preset) => (
        <PresetItem
          key={preset.key}
          isSelected={selectedPreset === preset.key}
          onClick={() => onPresetSelect(preset)}
        >
          <PresetLabel>
            {preset.label}
            {preset.isDefault && <PresetDefault>Default</PresetDefault>}
          </PresetLabel>
          {selectedPreset === preset.key && (
            <PresetCheck>
              <Icon name="Check" width="16" height="16" />
            </PresetCheck>
          )}
        </PresetItem>
      ))}
    </PresetListContainer>
  );
};
